<form [formGroup]="formGroup">
  <div class="p-card-header flex p-3 gap-2 align-items-center">
    <h3 class="mr-3">{{pageTitle}}</h3>
    <p-select
      [options]="profiles"
      optionLabel="name"
      optionValue="sarProfileId"
      [(ngModel)]="sarProfileId"
      (onChange)="onProfileChanged($event)"
      [ngModelOptions]="{standalone: true}"
    >
    </p-select>
    <div class="flex align-items-center">
      <p-button
        [text]="true"
        pTooltip="Create New"
        icon="pi pi-plus"
        (click)="createProfile()"
      ></p-button>
      <p-button
        *ngIf="profile"
        [text]="true"
        icon="pi pi-trash"
        severity="danger"
        mwlConfirmationPopover
        [title]="'Delete Selected SAR Profile'"
        [popoverMessage]="
              'You are going to delete selected SAR Profile. Are you sure?'
            "
        [appendToBody]="true"
        [confirmText]="'Yes'"
        [cancelText]="'No'"
        placement="bottom"
        (confirm)="removeProfile()"
      ></p-button>
    </div>
    <mat-form-field style="width: 50%">
      <mat-label>Name</mat-label>
      <input matInput name="name" formControlName="name" required />
    </mat-form-field>
    <p-button
      [text]="true"
      icon="pi pi-save"
      (click)="onDone()"
      *ngIf="profile"
    ></p-button>
  </div>
  <div style="display: flex; flex-direction: column;" id="sarProfileLayoutDiv" *ngIf="profile">
  <div>
        <mat-horizontal-stepper [linear]="false">
          <mat-step label="General Information" [stepControl]="{invalid: false}">
            <div>
              <mat-form-field>
                <mat-label>3PAO/IA Name</mat-label>
                <input matInput formControlName="iaName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>CSP Name</mat-label>
                <input matInput formControlName="cspName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>CSO Name</mat-label>
                <input matInput formControlName="csoName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Version</mat-label>
                <input matInput formControlName="version" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Date</mat-label>
                <input matInput formControlName="date" [matDatepicker]="pickerDate" required>
                <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerDate></mat-datepicker>
              </mat-form-field>
            </div>
            <p style="font-size:16px;">
              <strong style="padding-right: 10px;">Prepared By</strong>
            </p>
            <div>
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput formControlName="preparedByName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Address</mat-label>
                <input matInput formControlName="preparedByAddress" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Building</mat-label>
                <input matInput formControlName="preparedByBuilding" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>City</mat-label>
                <input matInput formControlName="preparedByCity" />
              </mat-form-field>
            </div>
            <p style="font-size:16px;">
              <strong style="padding-right: 10px;">Prepared For</strong>
            </p>
            <div>
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput formControlName="preparedForName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Address</mat-label>
                <input matInput formControlName="preparedForAddress" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Building</mat-label>
                <input matInput formControlName="preparedForBuilding" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>City</mat-label>
                <input matInput formControlName="preparedForCity" />
              </mat-form-field>
            </div>

            <p-table [value]="profile.sarExecutiveSummaries"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sarExecutiveSummaryId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table 2-1 Executive Summary Information</div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showExecutiveSummaryDialog()"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of executiveSummaryCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.identifier }}</td>
                  <td>{{ item.csp }}</td>
                  <td>{{ item.cso }}</td>
                  <td>{{ item.serviceModel }}</td>
                  <td>{{ item.deploymentModel }}</td>
                  <td>{{ item.impactLevel }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showExecutiveSummaryDialog(item)"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteExecutiveSummary(item)"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <p-table [value]="profile.sarRisks"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sarRiskId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table 2-2 Summary of Risks That Remained Open at the Conclusion of this
                    Assessment
                  </div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showRiskDialog()"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of riskCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.category }}</td>
                  <td>{{ item.total }}</td>
                  <td>{{ item.operationalRequirement }}</td>
                  <td>{{ item.vendorDependency }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showRiskDialog(item)"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteRisk(item)"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <p-table [value]="profile.sarSiteNameAndAddresses"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sarLsiteNameAndAddressId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table 2-3 Site Names and Addresses</div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showSiteNameAndAddressDialog()"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of siteNameAndAddressCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.dataCenterSiteName }}</td>
                  <td>{{ item.address }}</td>
                  <td>{{ item.description }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showSiteNameAndAddressDialog(item)"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteSiteNameAndAddress(item)"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <p-table [value]="profile.sarDeviations"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sarDeviationId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table 4-1 List of Assessment Deviations</div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showDeviationDialog()"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of deviationCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.id }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.justification }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showDeviationDialog(item)"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteDeviation(item)"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <p-table [value]="profile.sarScanSummaries"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sarScanSummaryId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table C-6 Summary of Unauthenticated Scans</div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showScanSummaryDialog()"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of scanSummaryCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.identifier }}</td>
                  <td>{{ item.componentDescription }}</td>
                  <td>{{ item.rationale }}</td>
                  <td>{{ item.metodologyDescription }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showScanSummaryDialog(item)"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteScanSummary(item)"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <p-table [value]="profile.sarAuxiliaryDocuments"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sarAuxiliaryDocumentId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table E-1 Auxiliary Documents</div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showAuxiliaryDocumentDialog()"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of auxiliaryDocumentCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.title }}</td>
                  <td>{{ item.version }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showAuxiliaryDocumentDialog(item)"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteAuxiliaryDocument(item)"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <div>
              <button mat-raised-button
                      matStepperPrevious
                      type="button">
                Back
              </button>
              <button mat-raised-button
                      matStepperNext
                      type="button">
                Next
              </button>
              <button mat-raised-button
                      (click)="onDone()">
                Save
              </button>
            </div>
          </mat-step>
          <mat-step label="Project" [stepControl]="{invalid: false}">
            <div>
              <mat-form-field>
                <mat-label>Project</mat-label>
                <mat-select formControlName="projectId" (selectionChange)="projectChanged($event)">
                  <mat-option [value]="project.projectId" *ngFor="let project of projects">{{ project.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>IT Profile</mat-label>
                <mat-select formControlName="clientItProfileId">
                  <mat-option [value]="itProfile.clientITProfileId"
                              *ngFor="let itProfile of projectItProfiles">{{ itProfile.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <button mat-raised-button
                      matStepperPrevious
                      type="button">
                Back
              </button>
              <button mat-raised-button
                      matStepperNext
                      type="button">
                Next
              </button>
              <button mat-raised-button
                      (click)="onDone()">
                Save
              </button>
            </div>

          </mat-step>
          <mat-step label="Executive Summary" [stepControl]="{invalid: false}">
            <div>
              <mat-form-field>
                <mat-label>Assessment</mat-label>
                <mat-select formControlName="assessmentType">
                  <mat-option [value]="0">an initial assessment</mat-option>
                  <mat-option [value]="1">an annual assessment</mat-option>
                  <mat-option [value]="2">a combined annual assessment and significant change assessment</mat-option>
                  <mat-option [value]="3">a significant change assessment</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>recorded in the CSO SSP/SSP and significant change documentation/significant change
                  documentation
                </mat-label>
                <mat-select formControlName="isSignificantChangeDocumentationAndSsp">
                  <mat-option [value]="false">SSP/SSP and significant change documentation</mat-option>
                  <mat-option [value]="true">significant change documentation</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>The assessment took place from initial and remediation testing window/began-ended</mat-label>
                <mat-select formControlName="datesType">
                  <mat-option [value]="0">
                    for initial testing window MM/DD/YYYY to MM/DD/YYYY and remediation testing
                    window MM/DD/YYYY to MM/DD/YYYY
                  </mat-option>
                  <mat-option [value]="1">this assessment began MM/DD/YYYY and ended MM/DD/YYYY</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Initial Testing Window From</mat-label>
                <input matInput formControlName="initialStart" [matDatepicker]="pickerInitialStart"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerInitialStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerInitialStart></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Initial Testing Window To</mat-label>
                <input matInput formControlName="initialEnd" [matDatepicker]="pickerInitialEnd"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerInitialEnd"></mat-datepicker-toggle>
                <mat-datepicker #pickerInitialEnd></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Remediation Testing Window From</mat-label>
                <input matInput formControlName="remediationStart" [matDatepicker]="pickerRemediationStart"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerRemediationStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerRemediationStart></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Remediation Testing Window To</mat-label>
                <input matInput formControlName="remediationEnd" [matDatepicker]="pickerRemediationEnd"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerRemediationEnd"></mat-datepicker-toggle>
                <mat-datepicker #pickerRemediationEnd></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Assessment began</mat-label>
                <input matInput formControlName="assessmentStart" [matDatepicker]="pickerAssessmentStart"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerAssessmentStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerAssessmentStart></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Assessment ended</mat-label>
                <input matInput formControlName="assessmentEnd" [matDatepicker]="pickerAssessmentEnd"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerAssessmentEnd"></mat-datepicker-toggle>
                <mat-datepicker #pickerAssessmentEnd></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Initial Assessment Baseling</mat-label>
                <mat-select formControlName="baselineInitial">
                  <mat-option [value]="0">Low</mat-option>
                  <mat-option [value]="1">Moderate</mat-option>
                  <mat-option [value]="2">High</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Annual Assessment Baseling</mat-label>
                <mat-select formControlName="baselineAnnual">
                  <mat-option [value]="0">Low</mat-option>
                  <mat-option [value]="1">Moderate</mat-option>
                  <mat-option [value]="2">High</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Separate Assessment Plan</mat-label>
                <mat-select formControlName="isForAlsoIncludes">
                  <mat-option [value]="false">Yes</mat-option>
                  <mat-option [value]="true">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Separate Assessment Plan</mat-label>
                <mat-select formControlName="isForAlsoIncludes">
                  <mat-option [value]="0">Yes</mat-option>
                  <mat-option [value]="1">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>assessment completed for</mat-label>
                <mat-select formControlName="changeChanges">
                  <mat-option [value]="0">a significant change</mat-option>
                  <mat-option [value]="1">several significant changes</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>AO/JAB</mat-label>
                <mat-select formControlName="aoJab">
                  <mat-option [value]="0">AO</mat-option>
                  <mat-option [value]="1">JAB</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Related</mat-label>
                <mat-select formControlName="relatedActivities">
                  <mat-option [value]="0">all items related to continuous monitoring activities</mat-option>
                  <mat-option [value]="1">
                    all items related to continuous monitoring activities as well as those that are
                    applicable to the significant change assessment
                  </mat-option>
                  <mat-option [value]="2">
                    continuous monitoring activities that are applicable to the significant change
                    assessment. &lt;Insert IA Name&gt; did evaluate all open POA&M items (including VDs); POA&M closures
                    (to confirm adequate closure) and validate and confirm continued relevance and applicability of DRs
                    ((false positives (FPs), risk adjustments (RAs), and operational requirements (ORs))
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Include Applicable</mat-label>
                <mat-select formControlName="includingThoseApplicable">
                  <mat-option [value]="0">including those applicable to the significant change assessment</mat-option>
                  <mat-option [value]="1">applicable to the significant change assessment</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>SAP Version</mat-label>
                <input matInput formControlName="sapVersion" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>SAP Date</mat-label>
                <input matInput formControlName="sapVersionDate" [matDatepicker]="pickerSapVersionDate"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerSapVersionDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerSapVersionDate></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <span>The following were completed for this assessment</span>
              <mat-checkbox formControlName="testingTypesManual">manual testing</mat-checkbox>
              <mat-checkbox formControlName="testingTypesPenetration">penetration testing</mat-checkbox>
              <mat-checkbox formControlName="testingTypesWeb">web application vulnerability scans</mat-checkbox>
              <mat-checkbox formControlName="testingTypesDatabase">database vulnerability scans</mat-checkbox>
              <mat-checkbox formControlName="testingTypesOperationSystem">
                operating system vulnerability scans
              </mat-checkbox>
              <mat-checkbox formControlName="testingTypesContainer">container vulnerability scans</mat-checkbox>
            </div>
            <div>
              <button mat-raised-button
                      matStepperPrevious
                      type="button">
                Back
              </button>
              <button mat-raised-button
                      matStepperNext
                      type="button">
                Next
              </button>
              <button mat-raised-button
                      (click)="onDone()">
                Save
              </button>
            </div>
          </mat-step>
          <mat-step label="Recommendations" [stepControl]="{invalid: false}">
            <div>
              <mat-form-field>
                <mat-label>recommends this system for authorization</mat-label>
                <input matInput formControlName="recommendsName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>does not recommend this system for authorization</mat-label>
                <input matInput
                       formControlName="notRecommendsName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>recommends this system for continued authorization</mat-label>
                <input matInput
                       formControlName="recommendsContinued" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>does not recommend this system for continued authorization</mat-label>
                <input matInput
                       formControlName="notRecommendsContinued" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>recommends the following significant change included in this assessment for authorization
                </mat-label>
                <input matInput
                       formControlName="recommendsAssessment" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>recommends significant change/significant change(s)</mat-label>
                <mat-select formControlName="isRecommendsAssessmentMultiple">
                  <mat-option [value]="false">significant change</mat-option>
                  <mat-option [value]="true">significant change(s)</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>List the significant changes that are approved for authorization.</mat-label>
                <textarea matInput
                          type="text"
                          formControlName="approvedSignificantChanges">
                            </textarea>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>does not recommend the following significant change included in this assessment for
                  authorization
                </mat-label>
                <input matInput
                       formControlName="notRecommendsAssessment" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>not recommends significant change/significant change(s)</mat-label>
                <mat-select formControlName="isNotRecommendsAssessmentMultiple">
                  <mat-option [value]="false">significant change</mat-option>
                  <mat-option [value]="true">significant change(s)</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>List the significant changes that are not approved for authorization.</mat-label>
                <textarea matInput
                          type="text"
                          formControlName="notApprovedSignificantChanges">
                            </textarea>
              </mat-form-field>
            </div>
            <div>
              <button mat-raised-button
                      matStepperPrevious
                      type="button">
                Back
              </button>
              <button mat-raised-button
                      matStepperNext
                      type="button">
                Next
              </button>
              <button mat-raised-button
                      (click)="onDone()">
                Save
              </button>
            </div>
          </mat-step>
          <mat-step label="Infrastructure Scan Results" [stepControl]="{invalid: false}">
            <div>
              <mat-form-field>
                <mat-label>Infrastructure Scanner Name</mat-label>
                <input matInput formControlName="infrastructureScannerName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Infrastructure Scanner Vendor</mat-label>
                <input matInput formControlName="infrastructureScannerVendor" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Infrastructure Scanner Version</mat-label>
                <input matInput formControlName="infrastructureScannerVersion" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Infrastructure Percentage Scanned</mat-label>
                <input matInput formControlName="infrastructurePercentageScanned" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>not recommends significant change/significant change(s)</mat-label>
                <mat-select formControlName="isInfrastructureDiscrepancy">
                  <mat-option [value]="false">There were no discrepancies found between the scanned and documented
                    inventory
                  </mat-option>
                  <mat-option [value]="true">discrepancies with the scanned inventory and the documented inventory have
                    been recorded in the RET
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>The discrepancies were due to</mat-label>
                <textarea matInput
                          type="text"
                          formControlName="infrastructureDiscrepancyReasons">
                            </textarea>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Infrastructure Detect Date</mat-label>
                <input matInput formControlName="infrastructureScanDate" [matDatepicker]="pickerInfrastructureScanDate"
                       required>
                <mat-datepicker-toggle matSuffix [for]="pickerInfrastructureScanDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerInfrastructureScanDate></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <button mat-raised-button
                      matStepperPrevious
                      type="button">
                Back
              </button>
              <button mat-raised-button
                      matStepperNext
                      type="button">
                Next
              </button>
              <button mat-raised-button
                      (click)="onDone()">
                Save
              </button>
            </div>
          </mat-step>
          <mat-step label="Database Scan Results" [stepControl]="{invalid: false}">
            <div>
              <mat-form-field>
                <mat-label>Database Scanner Name</mat-label>
                <input matInput formControlName="dbScannerName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Database Scanner Vendor</mat-label>
                <input matInput formControlName="dbScannerVendor" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Database Scanner Version</mat-label>
                <input matInput formControlName="dbScannerVersion" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Database Percentage Scanned</mat-label>
                <input matInput formControlName="dbPercentageScanned" />
              </mat-form-field>
            </div>
            <div>
              <mat-checkbox formControlName="isDbScan">For the remaining inventory, the performed a manual review
              </mat-checkbox>
            </div>
            <div>
              <mat-form-field>
                <mat-label>not recommends significant change/significant change(s)</mat-label>
                <mat-select formControlName="isDbDiscrepancy">
                  <mat-option [value]="false">There were no discrepancies found between the scanned and documented
                    inventory
                  </mat-option>
                  <mat-option [value]="true">discrepancies with the scanned inventory and the documented inventory have
                    been recorded in the RET
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>The discrepancies were due to</mat-label>
                <textarea matInput
                          type="text"
                          formControlName="dbDiscrepancyReasons">
                            </textarea>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Database Detect Date</mat-label>
                <input matInput formControlName="dbScanDate" [matDatepicker]="pickerDatabaseScanDate" required>
                <mat-datepicker-toggle matSuffix [for]="pickerDatabaseScanDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerDatabaseScanDate></mat-datepicker>
              </mat-form-field>
            </div>

            <div>
              <button mat-raised-button
                      matStepperPrevious
                      type="button">
                Back
              </button>
              <button mat-raised-button
                      matStepperNext
                      type="button">
                Next
              </button>
              <button mat-raised-button
                      (click)="onDone()">
                Save
              </button>
            </div>
          </mat-step>
          <mat-step label="Web Scan Results" [stepControl]="{invalid: false}">
            <div>
              <mat-form-field>
                <mat-label>Web Scanner Name</mat-label>
                <input matInput formControlName="webScannerName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Web Scanner Vendor</mat-label>
                <input matInput formControlName="webScannerVendor" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Web Scanner Version</mat-label>
                <input matInput formControlName="webScannerVersion" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Web App Percentage Scanned</mat-label>
                <input matInput formControlName="webPercentageAppScanned" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Web API Percentage Scanned</mat-label>
                <input matInput formControlName="webPercentageApiScanned" />
              </mat-form-field>
            </div>
            <div>
              <mat-checkbox formControlName="isWebScan">For the remaining inventory, the performed a manual review
              </mat-checkbox>
            </div>
            <div>
              <mat-form-field>
                <mat-label>not recommends significant change/significant change(s)</mat-label>
                <mat-select formControlName="isWebDiscrepancy">
                  <mat-option [value]="false">There were no discrepancies found between the scanned and documented
                    inventory
                  </mat-option>
                  <mat-option [value]="true">discrepancies with the scanned inventory and the documented inventory have
                    been recorded in the RET
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>The discrepancies were due to</mat-label>
                <textarea matInput
                          type="text"
                          formControlName="webDiscrepancyReasons">
                            </textarea>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Web Detect Date</mat-label>
                <input matInput formControlName="webScanDate" [matDatepicker]="pickerWebScanDate" required>
                <mat-datepicker-toggle matSuffix [for]="pickerWebScanDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerWebScanDate></mat-datepicker>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field>
                <mat-label>Container Scanner Name</mat-label>
                <input matInput formControlName="containerScannerName" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Container Scanner Vendor</mat-label>
                <input matInput formControlName="containerScannerVendor" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Container Scanner Version</mat-label>
                <input matInput formControlName="containerScannerVersion" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Container Percentage Scanned</mat-label>
                <input matInput formControlName="containerPercentageScanned" />
              </mat-form-field>
            </div>
            <div>
              <mat-checkbox formControlName="isContainerScan">For the remaining inventory, the performed a manual
                review
              </mat-checkbox>
            </div>
            <div>
              <mat-form-field>
                <mat-label>not recommends significant change/significant change(s)</mat-label>
                <mat-select formControlName="isContainerDiscrepancy">
                  <mat-option [value]="false">There were no discrepancies found between the scanned and documented
                    inventory
                  </mat-option>
                  <mat-option [value]="true">discrepancies with the scanned inventory and the documented inventory have
                    been recorded in the RET
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>The discrepancies were due to</mat-label>
                <textarea matInput
                          type="text"
                          formControlName="containerDiscrepancyReasons">
                            </textarea>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Container Detect Date</mat-label>
                <input matInput formControlName="containerScanDate" [matDatepicker]="pickerContainerScanDate" required>
                <mat-datepicker-toggle matSuffix [for]="pickerContainerScanDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerContainerScanDate></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <button mat-raised-button
                      matStepperPrevious
                      type="button">
                Back
              </button>
              <button mat-raised-button
                      matStepperNext
                      type="button">
                Next
              </button>
              <button mat-raised-button
                      (click)="onDone()">
                Save
              </button>
            </div>
          </mat-step>
          <mat-step label="Other" [stepControl]="{invalid: false}">
            <div>
              <mat-form-field>
                <mat-label>Other Detect Date</mat-label>
                <input matInput formControlName="otherScanDate" [matDatepicker]="pickerOtherScanDate" required>
                <mat-datepicker-toggle matSuffix [for]="pickerOtherScanDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerOtherScanDate></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Penetration Test AuxiliaryDocument</mat-label>
                <input matInput formControlName="penTestLocation" />
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Penetration Test Date</mat-label>
                <input matInput formControlName="penTestDate" [matDatepicker]="pickerPenTestDate" required>
                <mat-datepicker-toggle matSuffix [for]="pickerPenTestDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerPenTestDate></mat-datepicker>
              </mat-form-field>
            </div>

            <p-table [value]="zipFiles['Infrastructure']"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sapZipFileId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table C-1 Infrastructure Scans: Raw Scan Zip File Index</div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showZipFileDialog({title : '', fileName : '', kind: 0}, zipFiles['Infrastructure'])"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.title }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showZipFileDialog(item, zipFiles['Infrastructure'])"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteZipFile(item, zipFiles['Infrastructure'])"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <p-table [value]="zipFiles['Db']"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sapZipFileId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table C-2 Database Scans: Raw Scan Zip File Index</div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showZipFileDialog({title : '', fileName : '', kind: 1}, zipFiles['Db'])"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.title }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showZipFileDialog(item, zipFiles['Db'])"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteZipFile(item, zipFiles['Db'])"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <p-table [value]="zipFiles['Web']"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sapZipFileId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table C-3 Web Application Scans: Raw Scan Zip File Index</div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showZipFileDialog({title : '', fileName : '', kind: 2}, zipFiles['Web'])"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.title }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showZipFileDialog(item, zipFiles['Web'])"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteZipFile(item, zipFiles['Web'])"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <p-table [value]="zipFiles['Container']"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sapZipFileId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table C-4 Container Scans: Raw Scan Zip File Index</div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showZipFileDialog({title : '', fileName : '', kind: 3}, zipFiles['Container'])"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.title }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showZipFileDialog(item, zipFiles['Container'])"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteZipFile(item, zipFiles['Container'])"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <p-table [value]="zipFiles['Other']"
                     [rows]="10"
                     selectionMode="single"
                     [paginator]="true"
                     [style]="{'margin-top':'10px'}"
                     sortField="sapZipFileId">

              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                  <div style="float: left;">Table C-5 Other Automated and Miscellaneous Tool Results: List of Raw Scan
                    Result Files
                  </div>
                  <button type="button"
                          pButton
                          icon="pi pi-plus"
                          (click)="showZipFileDialog({title : '', fileName : '', kind: 4}, zipFiles['Other'])"
                          label="Add"
                          class="risksponge-button"
                          style="float:right">
                  </button>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of zipFileCols" [pSortableColumn]="col.field"
                      [ngStyle]="{ width: col.width || 'auto' }">
                    {{ col.header }}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{width:'7em'}"></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                <tr>
                  <td>{{ item.title }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="showZipFileDialog(item, zipFiles['Other'])"
                            icon="pi pi-pencil">
                    </button>

                    <button type="button"
                            pButton
                            class="risksponge-button"
                            (click)="deleteZipFile(item, zipFiles['Other'])"
                            icon="pi pi-trash">
                    </button>
                  </td>
                </tr>
              </ng-template>

            </p-table>

            <div>
              <button mat-raised-button
                      matStepperPrevious
                      type="button">
                Back
              </button>
              <button mat-raised-button
                      matStepperNext
                      type="button">
                Next
              </button>
              <button mat-raised-button
                      (click)="onDone()">
                Save
              </button>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </div>
</form>

<p-dialog header="Table 2-1 Executive Summary Information"
          [(visible)]="executiveSummaryDialogVisible"

          showEffect="fade"
          [formGroup]="executiveSummaryFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>FedRAMP Unique Identifier</mat-label>
    <input matInput
           name="role"
           required
           formControlName="identifier">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>CSP</mat-label>
    <input matInput
           name="role"
           required
           formControlName="csp">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>CSO</mat-label>
    <input matInput
           name="role"
           required
           formControlName="cso">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Service Model</mat-label>
    <input matInput
           name="role"
           required
           formControlName="serviceModel">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Deployment Model</mat-label>
    <input matInput
           name="role"
           required
           formControlName="deploymentModel">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Impact Level</mat-label>
    <input matInput
           name="role"
           required
           formControlName="impactLevel">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveExecutiveSummary()">
        Save
      </button>


      <button mat-raised-button
              (click)="executiveSummaryDialogVisible = false; editedExecutiveSummary = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Table 2-2 Summary of Risks That Remained Open at the Conclusion of this Assessment"
          [(visible)]="riskDialogVisible"

          showEffect="fade"
          [formGroup]="riskFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Category</mat-label>
    <input matInput
           name="role"
           required
           formControlName="category">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Total</mat-label>
    <input matInput
           name="role"
           required
           formControlName="total">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Operational Requirement</mat-label>
    <input matInput
           name="role"
           required
           formControlName="operationalRequirement">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Vendor Dependency</mat-label>
    <input matInput
           name="role"
           required
           formControlName="vendorDependency">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveRisk()">
        Save
      </button>


      <button mat-raised-button
              (click)="riskDialogVisible = false; editedRisk = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Table 2-3 Site Names and Addresses"
          [(visible)]="siteNameAndAddressDialogVisible"

          showEffect="fade"
          [formGroup]="siteNameAndAddressFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Name</mat-label>
    <input matInput
           name="role"
           required
           formControlName="dataCenterSiteName">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Address</mat-label>
    <input matInput
           name="role"
           required
           formControlName="address">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Description of Components</mat-label>
    <input matInput
           name="role"
           required
           formControlName="description">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveSiteNameAndAddress()">
        Save
      </button>


      <button mat-raised-button
              (click)="siteNameAndAddressDialogVisible = false; editedSiteNameAndAddress = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Table 4-1 List of Assessment Deviations"
          [(visible)]="deviationDialogVisible"

          showEffect="fade"
          [formGroup]="deviationFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Deviation ID</mat-label>
    <input matInput
           name="role"
           required
           formControlName="id">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Description of Components</mat-label>
    <input matInput
           name="role"
           required
           formControlName="description">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Justification</mat-label>
    <input matInput
           name="role"
           required
           formControlName="justification">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveDeviation()">
        Save
      </button>


      <button mat-raised-button
              (click)="deviationDialogVisible = false; editedDeviation = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Zip File"
          [(visible)]="zipFileDialogVisible"

          showEffect="fade"
          [formGroup]="zipFileFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Title</mat-label>
    <input matInput
           name="role"
           required
           formControlName="title">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>File Name (Include Extension)</mat-label>
    <input matInput
           name="role"
           required
           [readonly]="editedZipFile?.sarZipFileAttachmentId"
           formControlName="fileName">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <label for="fileBlob2" class="btn">
    <i class="pi pi-plus"></i>
    <input id="fileBlob2"
           type="file"
           (change)="AddZipFile($event)"
           name="addAttachedFile2"
           style="display: none;" />
  </label>

  <a
    [href]="api + '/api/attachments/file?name=' + encodeURIComponent(editedZipFile?.internalName) + '&path=Account/SAR Profiles' + '&token=' + token"
    *ngIf="editedZipFile?.sarZipFileAttachmentId">{{ editedZipFile.fileName }}</a>


  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveZipFile()">
        Save
      </button>


      <button mat-raised-button
              (click)="zipFileDialogVisible = false; editedZipFile = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Table C-6 Summary of Unauthenticated Scans"
          [(visible)]="scanSummaryDialogVisible"

          showEffect="fade"
          [formGroup]="scanSummaryFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Identifier</mat-label>
    <input matInput
           name="role"
           required
           formControlName="identifier">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Product/Embedded Component Description</mat-label>
    <input matInput
           name="role"
           required
           formControlName="componentDescription">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Rationale</mat-label>
    <input matInput
           name="role"
           required
           formControlName="rationale">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Alternative Assessment Methodology Description</mat-label>
    <input matInput
           name="role"
           required
           formControlName="metodologyDescription">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveScanSummary()">
        Save
      </button>


      <button mat-raised-button
              (click)="scanSummaryDialogVisible = false; editedScanSummary = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Table E-1 Auxiliary Documents"
          [(visible)]="auxiliaryDocumentDialogVisible"

          showEffect="fade"
          [formGroup]="auxiliaryDocumentFormGroup">

  <mat-form-field class="dialog-control-width">
    <mat-label>Title</mat-label>
    <input matInput
           name="role"
           required
           formControlName="title">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Version</mat-label>
    <input matInput
           name="role"
           required
           formControlName="version">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <mat-form-field class="dialog-control-width">
    <mat-label>Filename</mat-label>
    <input matInput
           name="role"
           required
           [readonly]="editedAuxiliaryDocument?.sarZipFileAttachmentId"
           formControlName="fileName">
    <mat-error>This field is required</mat-error>
  </mat-form-field>

  <label for="fileBlob3" class="btn">
    <i class="pi pi-plus"></i>
    <input id="fileBlob3"
           type="file"
           (change)="AddAuxiliaryFile($event)"
           name="addAttachedFile3"
           style="display: none;" />
  </label>

  <a
    [href]="api + '/api/attachments/file?name=' + encodeURIComponent(editedZipFile?.internalName) + '&path=Account/SAR Profiles' + '&token=' + token"
    *ngIf="editedAuxiliaryDocument?.sarZipFileAttachmentId">{{ editedAuxiliaryDocument.fileName }}</a>

  <p-footer>
    <alert></alert>
    <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
      <button mat-raised-button
              (click)="saveAuxiliaryDocument()">
        Save
      </button>


      <button mat-raised-button
              (click)="auxiliaryDocumentDialogVisible = false; editedAuxiliaryDocument = null">
        Cancel
      </button>
    </div>
  </p-footer>
</p-dialog>

